// extracted by mini-css-extract-plugin
export default {"wrapper":"NA-z","viewport":"OA-z","container":"PA-z","slide":"QA-z"};